export default "__VITE_ASSET__BXKS$g7R__"